import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export function GraphResponseTimeFrecuencyInfo(props) {
  const { t } = useTranslation();
  const showInfo = () => {
    return {
      nameStep: props.step,
      x: props.x,
      y: props.y,
    };
  };

  if (!props.x) {
    return null;
  }

  const { nameStep, x, y } = showInfo();

  return (
    <Typography
      variant="h4"
      style={{
        fontSize: '13px',
        float: 'left',
        paddingLeft: '5px',
        color: '#66788A',
      }}
    >
      <h5>{nameStep}</h5>
      <h1>{x}(s)</h1>
      <h5>
        {t('statistics.measurements')}: {y}
      </h5>
    </Typography>
  );
}
